// extracted by mini-css-extract-plugin
export default {"footerDateInfo":"footerDateInfo__7g-a-"};